import {isEmpty, isNil} from "lodash"
import {Deal, Product, ProductProvider} from "@irati/types"
import {isDigitalGlueProduct, isWeGiftProduct} from "@irati-internal/app/src/helpers/product/isExternal"

const locales = [
  {locale: "en-GB", currency: "GBP"},
  {locale: "en-AU", currency: "AUD"},
  {locale: "fr-FR", currency: "EUR"},
  {locale: "en-IE", currency: "EUR"},
  {locale: "en-EX", currency: "TT"}
]

export default function getCurrencyForDeal(deal: Deal) {
  if (deal) {
    if (!isEmpty(deal.productConfig?.products)) {
      return getCurrencyForProduct(deal.productConfig.products[0])
    } else if (!isNil(deal.locale)) {
      // ew, really best guessing here
      const item = locales.find((l) => l.locale === deal.locale)
      return item?.currency || ""
    }
  }

  return ""
}

export function getProductCurrencyByDeal(deal: Deal) {
  if (!isEmpty(deal?.productConfig?.products)) {
    return getCurrencyForProduct(deal.productConfig.products[0])
  }
  // return null for deals w/o products (eg. competition || free deals w/o stock assignment)
  return null
}

export function getCurrencyForProduct(product: Product) {
  const currency = product?.currency || product?.salePrice?.currency
  if (currency) {
    return currency
  }
  // ew, really best guessing here
  const item = locales.find((l) => l.locale === product.locale)
  return item?.currency || ""
}

export function getProviderFromLegacySupplierList(product: Product) {
  if (isWeGiftProduct(product)) {
    return ProductProvider.Wegift
  }
  if (isDigitalGlueProduct(product)) {
    return ProductProvider.Digitalglue
  }
  if (product.type !== "External") {
    return ProductProvider.Stock
  }
  return product.provider
}
